import { SHIPMENT_SUBSTATUS } from './shipment-substatuses';

export enum SHIPMENT_STATUSES {
  OPENED = 'opened',
  AWAITING_LOAD_INFORMATION = 'awaiting_load_information',
  CONTRACTING = 'contracting',
  DISPATCHING = 'dispatching',
  AWAITING_PICKUP = 'awaiting_pickup',
  IN_ROUTE_TO_PICKUP = 'in_route_to_pickup',
  AT_PICKUP = 'at_pickup',
  PICKED_UP = 'picked_up',
  DEPARTED_PICKUP = 'departed_pickup',
  IN_TRANSIT = 'in_transit',
  DEPARTED_DELIVERY = 'departed_delivery',
  AT_DELIVERY = 'at_delivery',
  DELIVERED = 'delivered',
  CLOSED = 'closed',
  CANCELED = 'canceled',
}

type ShipmentStatusLabels = {
  [key in SHIPMENT_STATUSES]: string;
};

type ShipmentSubStatusLabels = {
  [key in SHIPMENT_SUBSTATUS]: string;
};

type CombinedShipmentStatusLabel = ShipmentStatusLabels & ShipmentSubStatusLabels;
export const SHIPMENT_STATUS_LABELS: CombinedShipmentStatusLabel = {
  [SHIPMENT_STATUSES.OPENED]: 'shipmentStatus_opened',
  [SHIPMENT_STATUSES.AWAITING_LOAD_INFORMATION]: 'shipmentStatus_awaitingLoadInformation',
  [SHIPMENT_STATUSES.CONTRACTING]: 'shipmentStatus_contracting',
  [SHIPMENT_STATUSES.DISPATCHING]: 'shipmentStatus_dispatching',
  [SHIPMENT_STATUSES.AWAITING_PICKUP]: 'shipmentStatus_awaitingPickup',
  [SHIPMENT_STATUSES.IN_ROUTE_TO_PICKUP]: 'shipmentStatus_inRouteToPickup',
  [SHIPMENT_STATUSES.AT_PICKUP]: 'shipmentStatus_atPickup',
  [SHIPMENT_STATUSES.PICKED_UP]: 'shipmentStatus_pickedUp',
  [SHIPMENT_STATUSES.DEPARTED_PICKUP]: 'shipmentStatus_departedPickup',
  [SHIPMENT_STATUSES.IN_TRANSIT]: 'shipmentStatus_inTransit',
  [SHIPMENT_STATUSES.DEPARTED_DELIVERY]: 'shipmentStatus_departedDelivery',
  [SHIPMENT_STATUSES.AT_DELIVERY]: 'shipmentStatus_atDelivery',
  [SHIPMENT_STATUSES.DELIVERED]: 'shipmentStatus_delivered',
  [SHIPMENT_STATUSES.CLOSED]: 'shipmentStatus_closed',
  [SHIPMENT_STATUSES.CANCELED]: 'shipmentStatus_canceled',

  [SHIPMENT_SUBSTATUS.AT_ORIGIN_AIRPORT]: 'shipmentStatus_atOriginAirport',
  [SHIPMENT_SUBSTATUS.AT_INT_AIRPORT]: 'shipmentStatus_atIntermediateAirport',
  [SHIPMENT_SUBSTATUS.AT_DEST_AIRPORT]: 'shipmentStatus_atDestinationAirport',
  [SHIPMENT_SUBSTATUS.AT_ORIGIN_PORT]: 'shipmentStatus_atOriginPort',
  [SHIPMENT_SUBSTATUS.AT_INT_PORT]: 'shipmentStatus_atIntermediatePort',
  [SHIPMENT_SUBSTATUS.AT_DEST_PORT]: 'shipmentStatus_atDestinationPort',
};